import { hmsAPI } from '@/api'

export const postComparesRaceImages =  images => hmsAPI.post(`/compares`, images)
export const getComparesRaceImages =  (raceId, params) => hmsAPI.get(`/raceimages/${raceId}/compares`, { params })
export const getCompare =  compareId => hmsAPI.get(`/compares/${compareId}`)
export const deleteCompare =  params => hmsAPI.delete(`/compares`, { params })
export const putCompare =  (compareId, compare) => hmsAPI.put(`/compares/${compareId}`, compare)
export const downloadCompare =  compareId => hmsAPI.get(`/download/compares/${compareId}`)
